import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { bookingOperations, bookingTypes } from '../../store/booking';
import { DAS_GET_BOOKING_FAILED } from '../../constants/errors';
import { createError } from '../../store/errors';
import { getBooking } from '../../api/booking';
import { getTicketAllocations } from '../../api/tickets';
import selectGetBookingLoading from '../../selectors/booking/getBookingLoading';

const { GET_BOOKING } = bookingTypes;

export const performGetBooking = function* performGetBooking({ payload }) {
  const {
    getBookingSuccess,
    getBookingLoading,
    getBookingFailure,
  } = bookingOperations;

  const { booking_ref } = payload;
  const isBookingLoading = yield select(selectGetBookingLoading, booking_ref);
  if (!isBookingLoading) {
    yield put(getBookingLoading(booking_ref, true));
    try {
      const { booking, errors } = yield call(getBooking, booking_ref);
      if (errors) {
        // Handle web service errors.
        yield put(getBookingFailure(booking_ref));
        yield all(errors.map(error => put(createError(error))));
      } else {
        const {
          error,
          errors: ticketAllocationsErrors,
          ticketAllocations,
        } = yield call(getTicketAllocations, booking.id);

        if (error) {
          yield put(createError(error));
        } else if (ticketAllocationsErrors) {
          yield all(ticketAllocationsErrors.map(err => put(createError(err))));
        } else {
          yield put(
            getBookingSuccess({
              ...booking,
              ticket_allocations: ticketAllocations,
            }),
          );
        }
      }
    } catch (error) {
      yield put(getBookingFailure(booking_ref));
      yield put(
        createError({
          code: DAS_GET_BOOKING_FAILED,
        }),
      );
    }
  }
};

export default takeEvery(GET_BOOKING, performGetBooking);
